// extracted by mini-css-extract-plugin
export var actionButton = "_d0-t";
export var buttonContainer = "_d0-0";
export var buttonContainer2 = "_d0-1";
export var buttonSection = "_d0-2";
export var details = "_d0-3";
export var dropdownItem = "_d0-5";
export var dropdownItemsContainer = "_d0-4";
export var fileInput = "_d0-r";
export var headerButton = "_d0-6";
export var icon = "_d0-7";
export var input = "_d0-8";
export var macroListItem = "_d0-9";
export var mainContent = "_d0-a";
export var microText = "_d0-b";
export var modal = "_d0-w";
export var optionsButton = "_d0-c";
export var paperclip = "_d0-s";
export var pillContent = "_d0-d";
export var preview = "_d0-e";
export var preview2 = "_d0-f";
export var quillEditor = "_d0-q";
export var selectedMacro = "_d0-g";
export var sidebar = "_d0-h";
export var sidebarHeader = "_d0-j";
export var sidebarList = "_d0-i";
export var sidebarListItem = "_d0-k";
export var sidebarSearch = "_d0-l";
export var snoozeDurationWrapper = "_d0-v";
export var statusPillContainer = "_d0-m";
export var tagsContainer = "_d0-n";
export var unselectedMacro = "_d0-o";
export var variable = "_d0-u";
export var wrapper = "_d0-p";